<template>
  <div class="dashboardlayout">
    <SideNav class="mb-6" />
    <router-view />
  </div>
</template>

<script>
import SideNav from "@/components/SideNav.vue";

export default {
  name: `DashboardLayout`,
  components: {
    SideNav
  }
};
</script>
